import { TextBoxComponent } from "@syncfusion/ej2-react-inputs";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { db } from "../../firebase";
import mailer from "../../service/api/mailer";
import { decrypt, encrypt } from "../../service/encryption/Encryption";

const Password = ({ isOpen, onClose }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPasswords, setShowPasswords] = useState({
    current: false,
    new: false,
    confirm: false,
  });
  const [error, setError] = useState("");
  const selectedUserId = sessionStorage.getItem("userId");

  if (!isOpen) return null;

  // const updateEmployeePassword = async () => {
  //   const employeeId = JSON.parse(
  //     sessionStorage.getItem("employeeDetails")
  //   ).darci_id;
  //   const usersRef = collection(db, "users");
  //   const q = query(usersRef, where("darci_id", "==", employeeId));
  //   const querySnapshot = await getDocs(q);

  //   if (!querySnapshot.empty) {
  //     const userDoc = querySnapshot.docs[0];
  //     const userData = userDoc.data();

  //     // Verify current password
  //     const decryptedPassword = decrypt(userData.password);
  //     if (currentPassword !== decryptedPassword) {
  //       throw new Error("wrong-password");
  //     }

  //     await updateDoc(userDoc.ref, {
  //       password: encrypt(newPassword),
  //       password_changed: true,
  //     });
  //     sessionStorage.setItem("needToUpdatePassword", "false");
  //   }
  // };

  const updateEmployeePassword = async () => {
    const employee = JSON.parse(sessionStorage.getItem("employeeDetails"));
    const usersRef = collection(db, "users");

    let userDoc;
    try {
      if (employee?.darci_id) {
        const q = query(usersRef, where("darci_id", "==", employee?.darci_id));
        const querySnapshot = await getDocs(q);
        userDoc = querySnapshot.docs[0];
      } else if (employee?.id) {
        const docRef = doc(db, "users", employee.id);
        userDoc = await getDoc(docRef);
      } else if (employee?.email) {
        const q = query(usersRef, where("email", "==", employee?.email));
        const querySnapshot = await getDocs(q);
        userDoc = querySnapshot.docs[0];
      } else {
        throw new Error("No employee ID found");
      }

      if (!userDoc || !userDoc.exists()) {
        throw new Error("User not found");
      }

      const userData = userDoc.data();
      // Verify current password
      const decryptedPassword = decrypt(userData.password);
      if (currentPassword !== decryptedPassword) {
        throw new Error("wrong-password");
      }

      await updateDoc(userDoc.ref, {
        password: encrypt(newPassword),
        password_changed: true,
      });
      sessionStorage.setItem("needToUpdatePassword", "false");
    } catch (error) {
      console.error("Error updating password:", error);
      throw error;
    }
  };

  const updateUserPassword = async () => {
    const userDocRef = doc(db, "users", selectedUserId);
    await updateDoc(userDocRef, {
      password: encrypt(newPassword),
    });

    const userDocSnap = await getDoc(userDocRef);
    const email = userDocSnap.data().email;

    console.log("Password changed successfully");
    await mailer.sendChangePasswordEmail(email, "Van");
  };

  const validatePasswords = () => {
    // Check if passwords match
    if (newPassword !== confirmPassword) {
      setError("New password and confirm password don't match.");
      return false;
    }

    // Check minimum length
    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters long.");
      return false;
    }

    // Check for uppercase letter
    if (!/[A-Z]/.test(newPassword)) {
      setError("Password must contain at least one uppercase letter.");
      return false;
    }

    // Check for special character or number
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?0-9]+/.test(newPassword)) {
      setError(
        "Password must contain at least one special character or number."
      );
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!validatePasswords()) return;
    console.log("ss", sessionStorage.getItem("employeeDetails"));

    try {
      if (sessionStorage.getItem("employeeDetails")) {
        console.log("Updating employee password");
        await updateEmployeePassword();
      } else {
        console.log("Updating user password");
        await updateUserPassword();
      }
      onClose();
    } catch (error) {
      if (error.message === "wrong-password") {
        setError("Current password is incorrect.");
      } else {
        setError("An error occurred. Please try again.");
        console.error("Error changing password:", error);
      }
    }
  };

  const togglePasswordVisibility = (field) => {
    setShowPasswords((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const renderPasswordField = (
    field,
    placeholder,
    value,
    setValue,
    isLast = false
  ) => (
    <div className={`relative ${isLast ? "mb-6" : "mb-4"}`}>
      <TextBoxComponent
        placeholder={placeholder}
        type={showPasswords[field] ? "text" : "password"}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        cssClass="e-outline"
        floatLabelType="Auto"
        onPaste={(e) => e.preventDefault()}
      />
      <button
        type="button"
        onClick={() => togglePasswordVisibility(field)}
        className="absolute right-3 top-1/2 -translate-y-1/2 transform cursor-pointer text-blue-500"
      >
        {showPasswords[field] ? <FaEyeSlash /> : <FaEye />}
      </button>
    </div>
  );

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-auto bg-black bg-opacity-50">
      <div className="w-[480px] rounded-lg bg-white shadow-xl">
        <div className="bg-blue flex items-center justify-between rounded-t-lg p-4">
          <h2 className="text-[24px] font-semibold">Change Password</h2>
          {!sessionStorage.getItem("needToUpdatePassword") && (
            <button
              onClick={onClose}
              className="bg-blue cursor-pointer rounded-full text-[24px] text-white"
            >
              &times;
            </button>
          )}
        </div>
        <form onSubmit={handleSubmit} className="p-6">
          {error && <div className="mb-4 text-red-500">{error}</div>}
          {renderPasswordField(
            "current",
            "Current Password",
            currentPassword,
            setCurrentPassword
          )}
          {renderPasswordField(
            "new",
            "New Password",
            newPassword,
            setNewPassword
          )}
          {renderPasswordField(
            "confirm",
            "Confirm New Password",
            confirmPassword,
            setConfirmPassword,
            true
          )}
          <div className="flex items-center justify-end space-x-4">
            {!sessionStorage.getItem("needToUpdatePassword") && (
              <button
                type="button"
                onClick={onClose}
                className="btn-cancel cursor-pointer rounded-full border px-4 py-2 transition duration-300 hover:bg-blue-50"
              >
                CANCEL
              </button>
            )}
            <button
              type="submit"
              className="btn-default cursor-pointer rounded-full px-4 py-2 transition duration-300 hover:bg-blue-600"
            >
              SAVE CHANGES
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Password;
